import { LICENSE } from './CommonConstants';
import { GRADE } from '../shared/GradesConstants';

const { KINDERGARTEN, PREKINDERGARTEN, FIRST_GRADE, SECOND_GRADE, THIRD_GRADE } = GRADE;

export const lexileGradeAvailability = [
    PREKINDERGARTEN,
    KINDERGARTEN,
    FIRST_GRADE,
    SECOND_GRADE,
    THIRD_GRADE,
];

export const isAvailableLexileToggle = (grades, licensingInfo) =>
    licensingInfo.includes(LICENSE.D8) &&
    lexileGradeAvailability.some(grade => grades.includes(grade));
